// extracted by mini-css-extract-plugin
module.exports = {"posts__wrapp":"b_b"};